module.exports = __webpack_public_path__ + "static/media/ecommerce.acf524a9.jpg";